import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-950 text-background-50 pt-16 pb-8">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="mb-12">
          <h2 className="text-4xl md:text-5xl font-heading font-bold tracking-tight">
            {t('footer.brand')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
          <div>
            <p className="text-foreground-200 text-sm leading-relaxed max-w-xs">
              {t('footer.description')}
            </p>
            <div className="flex items-center gap-4 mt-6">
              {['ri-instagram-line', 'ri-telegram-line', 'ri-pinterest-line', 'ri-twitter-x-line'].map((icon) => (
                <span key={icon} className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-300 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer">
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-xs font-label font-semibold uppercase tracking-widest text-foreground-400 mb-6">
              {t('footer.links')}
            </h3>
            <div className="flex flex-col gap-4">
              <Link to="/" className="text-sm text-foreground-200 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                {t('footer.home')}
              </Link>
              <Link to="/article/yoybuy-spreadsheet-guide" className="text-sm text-foreground-200 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                {t('footer.blog')}
              </Link>
              <a href="#" className="text-sm text-foreground-200 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                {t('footer.privacy')}
              </a>
              <a href="#" className="text-sm text-foreground-200 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                {t('footer.terms')}
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-xs font-label font-semibold uppercase tracking-widest text-foreground-400 mb-6">
              {t('footer.categories')}
            </h3>
            <div className="flex flex-col gap-4">
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-200 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">Обувь</a>
              <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-200 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">Футболки</a>
              <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-200 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">Куртки</a>
              <a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-200 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">Аксессуары</a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-foreground-700">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              {t('footer.copyright')}
            </p>
            <div className="flex items-center gap-6">
              <Link to="/" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">{t('footer.home')}</Link>
              <Link to="/article/yoybuy-spreadsheet-guide" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">{t('footer.blog')}</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}